<ticker-card
  [titleText]="'crmContacts.analytics.leads' | translate"
  total="51"
  [percentage]="8.5"
  tone="info"
  icon="datapie"
></ticker-card>
